import React, { useState } from 'react';
import {
  Box,
  Button,
  CardContent,
  FormControl,
  InputAdornment,
  InputBase,
  TextField,
  Typography,
} from '@mui/material';
import {
  PersonOutlineOutlined,
  AccountBalanceOutlined,
  CalendarTodayOutlined,
  CreditCardOutlined,
  FileUploadOutlined,
} from '@mui/icons-material';
import { useNavigate } from 'react-router';
import store from '../../store/store';
import { saveBankDetailsApi } from '../../store/api/signup';

const BankDetails = ({ handleBack }: any) => {
  const navigate = useNavigate();

  const [bankDetails, setBankDetails] = useState({
    partyId: '',
    accountHolderName: '',
    bankName: '',
    accountNumber: '',
    ifscCode: '',
  });

  const handleOnchange = (event: any) => {
    setBankDetails({
      ...bankDetails,
      [event.target.id || event.target.name]: event.target.value,
    });
  };

  const handleContinue = () => {
    const dummy = {
      partyId: '65b348a052a92fca68462119',
      accountHolderName: 'ABC Society Ltd',
      bankName: 'HDFC Bank',
      accountNumber: '233452623528970',
      ifscCode: 'HDFC000212',
    };
    const reqBody: any = { ...dummy };
    store.dispatch(saveBankDetailsApi(reqBody)).then((res) => {
      if (res.payload === 200) {
        navigate('/signin');
      }
    });
  };

  return (
    <Box width={'100%'}>
      <CardContent className='signinContent' sx={{ p: 0, pt: 0.5 }}>
        <Typography variant='h5'>Bank Details</Typography>
      </CardContent>

      <Box display='flex' flexDirection={'column'} gap={1}>
        <FormControl sx={{ my: 1.5 }}>
          <InputBase
            id='gst-number'
            sx={{
              p: '5px 10px',
              border: '1px solid #DEDEDE',
              borderRadius: 1,
              backgroundColor: '#EEECEC',
              width: { xs: '100%', md: '32%' },
            }}
            size='small'
            defaultValue='GST Number- 29GGGGG1314R9Z6'
            disabled
          />
        </FormControl>

        <TextField
          id='accountHolderName'
          sx={{ width: { xs: '100%', md: '32%' } }}
          placeholder='Account Holder'
          size='small'
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <PersonOutlineOutlined fontSize='small' />
              </InputAdornment>
            ),
          }}
          value={bankDetails.accountHolderName}
          onChange={handleOnchange}
        />

        <TextField
          id='bankName'
          sx={{ width: { xs: '100%', md: '32%' } }}
          placeholder='Bank Name'
          size='small'
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <AccountBalanceOutlined fontSize='small' />
              </InputAdornment>
            ),
          }}
          value={bankDetails.bankName}
          onChange={handleOnchange}
        />

        <Box display={'flex'} gap={2}>
          <TextField
            id='accountNumber'
            sx={{ width: { xs: '100%', md: '32%' } }}
            placeholder='Account Number'
            size='small'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <CreditCardOutlined fontSize='small' />
                </InputAdornment>
              ),
            }}
            value={bankDetails.accountNumber}
            onChange={handleOnchange}
          />
          <TextField
            id='accountNumber'
            sx={{ width: { xs: '100%', md: '32%' } }}
            placeholder='Account Number'
            size='small'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <CreditCardOutlined fontSize='small' />
                </InputAdornment>
              ),
            }}
            value={bankDetails.accountNumber}
            onChange={handleOnchange}
          />
        </Box>

        <TextField
          id='ifscCode'
          sx={{ width: { xs: '100%', md: '32%' } }}
          placeholder='IFSC Code'
          size='small'
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <CalendarTodayOutlined fontSize='small' />
              </InputAdornment>
            ),
          }}
          value={bankDetails.ifscCode}
          onChange={handleOnchange}
        />

        <Box display={'flex'} gap={2}>
          <TextField
            id='panNumber'
            sx={{ width: { xs: '100%', md: '32%' } }}
            placeholder='PAN'
            size='small'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <FileUploadOutlined fontSize='small' />
                </InputAdornment>
              ),
            }}
            value={bankDetails.accountNumber}
            onChange={handleOnchange}
          />
          <TextField
            id='tinNumber'
            sx={{ width: { xs: '100%', md: '32%' } }}
            placeholder='TIN'
            size='small'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <FileUploadOutlined fontSize='small' />
                </InputAdornment>
              ),
            }}
            value={bankDetails.accountNumber}
            onChange={handleOnchange}
          />
          <TextField
            id='gstNumber'
            sx={{ width: { xs: '100%', md: '32%' } }}
            placeholder='GST'
            size='small'
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <FileUploadOutlined fontSize='small' />
                </InputAdornment>
              ),
            }}
            value={bankDetails.accountNumber}
            onChange={handleOnchange}
          />
        </Box>

        <Box display={'flex'} gap={3} sx={{ mt: 1 }}>
          {/* <FormControl>
            <Button
              variant='outlined'
              sx={{ borderRadius: 20, fontWeight: 'bold' }}
              onClick={handleBack}
            >
              BACK
            </Button>
          </FormControl> */}
          <FormControl>
            <Button
              variant='contained'
              sx={{ borderRadius: 20, fontWeight: 'bold' }}
              onClick={handleContinue}
            >
              SUBMIT
            </Button>
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
};

export default BankDetails;
